<script setup lang="ts">
import StfDivider from '@/ui/divider/StfDivider.vue';
import StfInput from '@/ui/input/StfInput.vue';
import { useOwnerStore } from '@/store/owner';
import {storeToRefs} from 'pinia';
import useInternalization from '@/composables/internalizable';
import useCountry from '@/composables/countryDependable';
import { computed } from 'vue';
import { CountryCode } from '@/config/country/type';
import { MarkOwnerType } from '@/core/interface/api-interface';
import useMobile from '@/composables/useMobileDependable';

const country = useCountry();
const {isMobile} = useMobile();
const { trans } = useInternalization(country);
const { 
    ownerType,
    businessNumber
} = storeToRefs(useOwnerStore());

const companyNumberPlaceholder = computed(() => {
    if (country.code === CountryCode.AU && ownerType.value === MarkOwnerType.PERSON) {
        if (isMobile.value) {
            return trans('message.contact.companyNumberPlaceholderForIndividualMobile');
        }
    
        return trans('message.contact.companyNumberPlaceholderForIndividual');
    }

    if (isMobile.value) {
        return trans('message.contact.companyNumberPlaceholderForCompanyMobile');
    }

    return trans('message.contact.companyNumberPlaceholder');
});

const companyNumberLabel = computed(() => {
    if (country.code === CountryCode.AU && ownerType.value === MarkOwnerType.PERSON) {
        return trans('message.contact.companyNumberLabelForIndividual');
    }

    return trans('message.contact.companyNumberLabel');
});
</script>

<template>
    <StfDivider></StfDivider>
    <StfInput
        v-model="businessNumber"
        :placeholder="companyNumberPlaceholder"
        class="mt-3"
        :label="companyNumberLabel"
    />
</template>
